export const aboutData = {
  brandName: '51黑料',
  tagline: '最新热门黑料爆料聚合平台',
  introduction: `51黑料是国内领先的娱乐八卦与黑料爆料聚合平台，致力于为网友提供最新、最全、最劲爆的娱乐圈黑料资讯。自成立以来，51黑料始终坚持"真实、快速、全面"的内容理念，汇聚来自全网的热门爆料信息，覆盖明星黑料、网红爆料、娱乐圈内幕、社会热点等多个领域。

我们拥有一支专业的编辑团队和遍布全网的信息采集网络，能够在第一时间捕捉到最新的爆料动态，并对信息的真实性和可靠性进行交叉验证。51黑料不仅是吃瓜群众的聚集地，更是了解娱乐圈真相的重要窗口。`,
  reputation: [
    {
      name: '网友小王',
      role: '忠实用户',
      content: '每天必刷51黑料，比微博热搜还快！很多娱乐圈的消息都是在这里先看到的，真的是吃瓜第一线。',
      rating: 5,
    },
    {
      name: '娱乐博主老李',
      role: '自媒体人',
      content: '作为娱乐博主，51黑料是我获取素材的重要来源。平台的信息更新速度非常快，而且很多独家爆料的准确率很高。',
      rating: 5,
    },
    {
      name: '吃瓜群众小美',
      role: '活跃用户',
      content: '51黑料的分类做得很好，想看明星看明星，想看网红看网红，非常方便。而且文章质量也不错，不是那种标题党。',
      rating: 4,
    },
    {
      name: '资深八卦爱好者',
      role: 'VIP用户',
      content: '关注51黑料已经两年了，见证了平台从无到有的成长。现在的爆料内容越来越丰富，时效性也越来越强，真心推荐！',
      rating: 5,
    },
  ],
  stats: [
    { label: '日活跃用户', value: '500万+' },
    { label: '日均爆料更新', value: '200+条' },
    { label: '累计爆料文章', value: '10万+' },
    { label: '合作媒体', value: '300+家' },
  ],
  contact: {
    email: 'contact@51heiliao.com',
    wechat: '51heiliao_official',
    weibo: '@51黑料官方',
    address: '北京市朝阳区望京科技园',
  },
};